// src/LoginForm.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginForm() {
  const [email, setEmail] = useState("test@example.com");
  const [password, setPassword] = useState("secret123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
   const navigate=useNavigate()
  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("https://gantasoft.in/rankridgeschool/dev/v1/users/apis/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const json = await res.json();
      if (!res.ok || !json.success) {
        throw new Error(json.message || "Login failed");
      }
      // store token; adapt to your app (localStorage, cookie, state manager)
      localStorage.setItem("auth_token", json.token);
      localStorage.setItem("user", JSON.stringify(json.user));
      setUser(json.user);
navigate("/")
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function logout() {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    setUser(null);
  }

  return (
    <div style={{ maxWidth: 360, margin: "40px auto", fontFamily: "system-ui" }}>
      <h2>Login</h2>
      {!user ? (
        <form onSubmit={onSubmit} style={{ display: "grid", gap: 12 }}>
          <label>
            <div>Email</div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: "100%", padding: 8, border: "1px solid #ccc", borderRadius: 6 }}
            />
          </label>

          <label>
            <div>Password</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%", padding: 8, border: "1px solid #ccc", borderRadius: 6 }}
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "10px 14px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              background: "#10b981",
              color: "#fff",
              fontWeight: 600
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          {error && <div style={{ color: "#dc2626" }}>{error}</div>}
        </form>
      ) : (
        <div style={{ marginTop: 16 }}>
          <div>Welcome, <strong>{user.name}</strong> ({user.email})</div>
          <button onClick={logout} style={{ marginTop: 12, padding: "8px 12px", borderRadius: 8, border: "1px solid #ccc" }}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
